import React from 'react'
import PropTypes from 'prop-types'

import ActivityHeader from './ActivityHeader'
import Assignments from './Assignments'
import Comments from './Comments'
import LinkDecorator from 'Components/Base/LinkDecorator'

const Task = ({ id, createdAt, link, author, comments, assignments, text, type, carePlanUuid }) => (
  <div className="activity">
    <ActivityHeader createdAt={createdAt} type={type} link={link} {...author} />

    <div className="activity__body">
      <p>
        <LinkDecorator>{text}</LinkDecorator>
      </p>

      <Assignments assignments={assignments} />
    </div>

    <hr />

    <Comments comments={comments} parentId={id} carePlanUuid={carePlanUuid} />
  </div>
)

Task.propTypes = {
  assignments: PropTypes.array,
  author: PropTypes.object.isRequired,
  carePlanUuid: PropTypes.string.isRequired,
  comments: PropTypes.array,
  createdAt: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

Task.defaultProps = {
  comments: [],
  assignments: [],
}

export default Task
